var map = {
	"./BURRITO.svg": "b21d",
	"./Beanie.jpg": "0287",
	"./Birria-Burrito.jpg": "d30b",
	"./Birria.jpg": "fdcf",
	"./Bowl-Birria.jpg": "1dbc",
	"./Bowl-Carnitas.jpg": "96a4",
	"./Bowl-Grilled-Chicken.jpg": "02d8",
	"./Bowl-Papas.jpg": "5fec",
	"./Bowl-Sweet-Potato.jpg": "3141",
	"./Carnitas.jpg": "2018",
	"./Chips.jpg": "38cb",
	"./Desert.jpg": "6af2",
	"./Guacamole.jpg": "363d",
	"./Kale-Salad.jpg": "e416",
	"./PLATES.svg": "1842",
	"./PRODUCT.svg": "75ef",
	"./Pastor.jpg": "2acd",
	"./Pibil.jpg": "d0ec",
	"./Pool-Nachos.jpg": "0a3f",
	"./Potato-chorizo.jpg": "562f",
	"./Pozole.jpg": "9a87",
	"./Quesabirria.jpg": "35f1",
	"./SPECIAL.svg": "ca36",
	"./STUFF.svg": "8548",
	"./Salad.jpg": "8dc9",
	"./Salsa-Macha.jpg": "59bc",
	"./Salsas.jpg": "a461",
	"./Salsas.webp": "6e66",
	"./TACOS.svg": "61e6",
	"./Taco-Birria.jpg": "f648",
	"./Taco-Carnitas.jpg": "40b1",
	"./Taco-Grilled-Chicken.jpg": "ed92",
	"./Taco-Papas.jpg": "124f",
	"./Taco-Sweet-Potato.jpg": "e5ac",
	"./Tinga.jpg": "8b43",
	"./coming-soon.png": "9793",
	"./dc-colour.svg": "f23f",
	"./dc.svg": "ee0d",
	"./down.svg": "58a0",
	"./greeting.gif": "6f49",
	"./right.svg": "9635",
	"./up.svg": "0096"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";